import {
  shutdowns_fetchError,
  shutdowns_fetchStart,
  shutdowns_fetchSuccess,
} from './types';

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const shutdownReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case shutdowns_fetchStart:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case shutdowns_fetchSuccess:
      return {
        ...state,
        loading: false,
        data: payload.data,
      };

    case shutdowns_fetchError:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return state;
  }
};

export default shutdownReducer; //shutdownStore
